import { render, staticRenderFns } from "./PayrollReviewLifecycle.vue?vue&type=template&id=28fdcccf"
import script from "./PayrollReviewLifecycle.vue?vue&type=script&lang=js"
export * from "./PayrollReviewLifecycle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports